import { useState } from 'react';
import classNames from 'classnames';

import './PricingComponentToggle.scss';
import { CollapseIcon } from '../../../Icons';

export default function PricingComponentToggle({ title, children }) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="pricing-component-toggle">
			<button
				type="button"
				className="pricing-component-toggle__button ty-c4"
				onClick={() => setIsOpen(prevIsOpen => !prevIsOpen)}
			>
				{title}
				<div
					className={classNames('pricing-component-toggle__icon', {
						'pricing-component-toggle__icon--isOpen': isOpen,
					})}
				>
					<CollapseIcon />
				</div>
			</button>
			{isOpen && <div className="pricing-component-toggle__children">{children}</div>}
		</div>
	);
}
